import { clampBackgroundScale, getBackgroundRenderedSize } from './floorPlanBackgroundImageState.js';

/**
 * @param {{
 *   worldX: number;
 *   worldY: number;
 *   baseWidthMeters: number;
 *   baseHeightMeters: number;
 *   scale?: number;
 *   rotationDegrees: number;
 *   metersPerPixel: number;
 *   center: { x: number; y: number };
 * }} params
 */
export function backgroundImageToThreeTransform({
  worldX,
  worldY,
  baseWidthMeters,
  baseHeightMeters,
  scale,
  rotationDegrees,
  metersPerPixel,
  center,
}) {
  const { widthMeters, heightMeters } = getBackgroundRenderedSize({
    baseWidthMeters,
    baseHeightMeters,
    scale: clampBackgroundScale(scale ?? 1),
  });
  const x = (worldX - center.x) * metersPerPixel;
  const z = (worldY - center.y) * metersPerPixel;
  return {
    position: { x, y: 0.001, z },
    widthMeters,
    heightMeters,
    rotationYRadians: (-rotationDegrees * Math.PI) / 180,
  };
}

/**
 * @param {number} metersPerPixel
 * @param {number} widthPx
 * @param {number} heightPx
 */
export function backgroundImageSizeMeters(metersPerPixel, widthPx, heightPx) {
  const mpp = Number.isFinite(metersPerPixel) && metersPerPixel > 0 ? metersPerPixel : 0.01;
  return {
    baseWidthMeters: widthPx * mpp,
    baseHeightMeters: heightPx * mpp,
  };
}
